// removed by extract-text-webpack-plugin
module.exports = {"app_content_less":"_3xNmunizRPLRMBCSXUNPhj"};


//////////////////
// WEBPACK FOOTER
// ./components/app/style.less
// module id = 72
// module chunks = 0